const getters = {
    token: (state) => state.user.token,
    avatar: (state) => state.user.avatar,
    routers: (state: any) => state.user.routers,
    name: (state) => state.user.name,
    root: (state: any) => state.user.root,
}
export default getters
